import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

export default function ModalTicket({ equipo, usuario, token, onClose }) {
    const [topics, setTopics] = useState([]);
    const [asunto, setAsunto] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [enviando, setEnviando] = useState(false);
    const [resultado, setResultado] = useState(null);
    const [error, setError] = useState('');
    useEffect(() => {
        if (!equipo) return;
        setAsunto('');
        setMensaje('');
        setEnviando(false);
        setResultado(null);
        setError('');
        fetch(`${API_URL}/osticket/topics`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(setTopics)
            .catch(() => setTopics([]));
    }, [equipo]);

    if (!equipo) return null;

    const handleEnviar = async (e) => {
        e.preventDefault();
        if (!asunto || !mensaje) return;
        setEnviando(true);
        setError('');
        try {
            const res = await fetch(`${API_URL}/osticket/ticket`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({
                    nombre: usuario.nombre_completo ?? usuario.nombre,
                    email: usuario.email,
                    asunto,
                    mensaje,
                    equipo: {
                        tipo_equipo: equipo.tipo_equipo,
                        marca: equipo.marca,
                        modelo: equipo.modelo,
                        numero_serie: equipo.numero_serie,
                        numero_inventario: equipo.numero_inventario,
                        estado: equipo.estado,
                    }
                })
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message);
            setResultado(data.ticket_id);
        } catch (err) {
            setError(err.message);
        } finally {
            setEnviando(false);
        }
    };

    return (
        <div className="overlay" onClick={onClose}>
            <div className="modal" onClick={e => e.stopPropagation()} style={{ width: 500 }}>

                <h3 style={{ marginTop: 0 }}>Levantar ticket — {equipo.marca} {equipo.modelo}</h3>
                <p style={{ fontSize: 12, color: '#888', marginBottom: 12 }}>
                    El ticket se levantará con el correo: <b>{usuario.email ?? '—'}</b>
                </p>

                {resultado ? (
                    <div style={{ textAlign: 'center', padding: '1.5rem 0' }}>
                        <div style={{ fontSize: 32, marginBottom: 8 }}>✅</div>
                        <p style={{ fontWeight: 600 }}>Ticket creado correctamente</p>
                        <p style={{ fontSize: 13, color: '#888' }}>ID: <b>{resultado}</b></p>
                        <button className="btn-primary" style={{ marginTop: 12 }} onClick={onClose}>Cerrar</button>
                    </div>
                ) : (
                    <form onSubmit={handleEnviar}>
                        <div className="form-group">
                            <label className="form-label required">Asunto</label>
                            <select className="form-input" value={asunto}
                                onChange={e => setAsunto(e.target.value)} required>
                                <option value="">-- Selecciona el tipo de problema --</option>
                                {topics.map(t => <option key={t} value={t}>{t}</option>)}
                            </select>
                        </div>

                        <div className="form-group">
                            <label className="form-label required">Descripción del problema</label>
                            <textarea className="form-input" rows={4}
                                placeholder="Describe el problema con detalle..."
                                value={mensaje} onChange={e => setMensaje(e.target.value)} required />
                        </div>

                        {/* Info del equipo */}
                        <div style={{
                            background: '#f5f5f5', borderRadius: 6, padding: '8px 12px',
                            fontSize: 12, color: '#666', marginBottom: 12
                        }}>
                            <b>Equipo:</b> {equipo.tipo_equipo} — {equipo.marca} {equipo.modelo}<br />
                            <b>N° Serie:</b> {equipo.numero_serie} &nbsp;|&nbsp;
                            <b>Estado:</b> {equipo.estado}
                        </div>

                        {error && (
                            <div style={{
                                background: '#fde8e8', border: '1px solid #f5c6c6', borderRadius: 4,
                                padding: '8px 12px', fontSize: 12, color: '#c0392b', marginBottom: 12
                            }}>
                                {error}
                            </div>
                        )}

                        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
                            <button type="button" className="btn-secondary" onClick={onClose}>Cancelar</button>
                            <button type="submit" className="btn-primary" disabled={enviando}>
                                {enviando ? 'Enviando...' : 'Crear ticket'}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}